import {Dispatch, SetStateAction, createContext, useState, useEffect } from "react";
import { ColorSchemeName, useColorScheme } from 'react-native';


interface contextTypeProps {
  colorScheme:ColorSchemeName;
}

interface ContextProps {
  state: contextTypeProps;
  setState: Dispatch<SetStateAction<contextTypeProps>>;
}
var DEFAULT_VALUE = {
  state: {
    colorScheme:"light" as ColorSchemeName,
  },
  setState: () => { },
}

export const Context = createContext<ContextProps>(DEFAULT_VALUE);

const ContextProvider = ({ children }: any) => {
  const scheme = useColorScheme();
  const [state, setState] = useState(DEFAULT_VALUE.state);
  useEffect(() => {
    setState({
      colorScheme:scheme
    });
  }, []);
  return (
    <Context.Provider
      value={{
        state,
        setState,
      }}
    >
      {children}
    </Context.Provider>
  )
}

export const GlobalContext = ({ children }:any) => {
  return(
<ContextProvider>
    {children}
  </ContextProvider>
  )
};